import clone from 'clone';
import { AJV_EXTENSION_PROPERTY_PATH } from '../../../../globals';
import { ISchemaRef, ISchemaRefContent } from './ref.types';

export * from './ref.types';

/**
 * Type.ref(ISchemaRefsTableTypePropertyValue)
 */
export function ref<Type extends ISchemaRefContent = ISchemaRefContent, ID extends string = string>(
    property_schema: Type
): ISchemaRef<Type, ID> {
    /**
     * We have two cases here:
     * 1. If we're referencing a top-level schema (indicated by the presence of an `$id` field), we sub in the $id directly
     * 2. If we're referencing an object property schema, we use the appended `AJV_EXTENSION_PROPERTY_PATH` value
     */

    //  Case 1: $id
    if (property_schema.$id) {
        //  Prune $id off of schema; will otherwise get an AJV compile() error
        const prop_schema = clone(property_schema);
        delete prop_schema.$id;

        return {
            ...prop_schema,
            $ref: `${property_schema.$id}#` as ID,
        };
    }

    //  Case 2: AJV_EXTENSION_PROPERTY_PATH
    else {
        const ref_path = property_schema[AJV_EXTENSION_PROPERTY_PATH];

        //  When formatting the schema for ajv consumption in formatSchemaForAJV(), we keep only $ref,
        //   and nest the rest of the type under the [AJV_EXTENSION_REF_SCHEMA] property
        return {
            ...property_schema,
            $ref: ref_path as ID,
        };
    }
}
